export default "__VITE_ASSET__BUaHn_If__"